
const m = window.require("@ember/-internals/error-handling");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
